/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

export enum ETransportNotificationCheckStatus {
  UNCHECKED = 'UNCHECKED',
  PENDING = 'PENDING',
  COMMUNICATION_ERROR = 'COMMUNICATION_ERROR',
  AUTHORIZATION_ERROR = 'AUTHORIZATION_ERROR',
  ERROR = 'ERROR',
  NOT_OK = 'NOT_OK',
  OK = 'OK',
}
